import { FocusNode } from '@please/lrud'
import styled from 'styled-components'

export const SelectButton = styled(FocusNode)`
  position: relative;
  display: flex;
  width: 300px;
  height: 48px;
  background: ${(props) => props.theme.colors.button.background};
  box-shadow: inset 0 0 0 1px ${(props) => props.theme.colors.button.border},
    0 0 0 1px ${(props) => props.theme.colors.button.border};
  box-sizing: border-box;
  margin: 8px 0;
  border-radius: 8px;
  overflow: hidden;
  & > :last-child {
    display: flex;
    flex: 0 0 44px;
    width: 44px;
    height: 100%;
    align-items: center;
    justify-content: center;
    background: ${(props) => props.theme.colors.button.backgroundIcon};
    img {
      max-height: 68%;
    }
  }
  .label {
    display: flex;
    flex: 0 1 100%;
    height: 100%;
    font-weight: 500;
    font-size: 18px;
    line-height: 44px;
    padding: 0 16px;
    align-items: left;
    color: ${(props) => props.theme.colors.button.text};
    display: -webkit-box;
    -webkit-line-clamp: 1;
    -webkit-box-orient: vertical;
    overflow: hidden;
  }
  &.isFocusedLeaf {
    box-shadow: inset 0 0 0 1px
        ${(props) => props.theme.colors.button.focusedElem.border},
      0 0 0 1px ${(props) => props.theme.colors.button.focusedElem.border};
    & > div:last-child {
      background-color: ${(props) => props.theme.colors.button.accent};
      img {
        filter: invert(75%) sepia(75%) saturate(520%) hue-rotate(150deg)
          brightness(90%) contrast(100%);
      }
    }
  }
`
export const SelectPopupBox = styled(FocusNode)`
  position: fixed;
  background: ${(props) => props.theme.colors.dialogPopup.overlay};
  width: 1920px;
  height: 1080px;
  top: 0;
  left: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 10;
`
export const SelectPopupElem = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  position: relative;
  width: 820px;
  height: auto;
  min-height: 30%;
  max-height: 84%;
  padding: 32px;
  border: 2px solid ${(props) => props.theme.colors.dialogPopup.border};
  border-radius: 24px;
  overflow: hidden;
  background-image: linear-gradient(
      115deg,
      rgba(255, 255, 255, 0.15) 0%,
      rgba(255, 255, 255, 0.15) 60%,
      rgba(255, 255, 255, 0.1) 60%,
      rgba(255, 255, 255, 0.1) 100%
    ),
    radial-gradient(
      85.28% 210.12% at 10.34% 14.72%,
      ${(props) => props.theme.colors.dialogPopup.background.start} 0%,
      ${(props) => props.theme.colors.dialogPopup.background.end} 100%
    );
`
export const Title = styled.h3`
  width: 100%;
  font-size: 40px;
  line-height: 1.2;
  color: ${(props) => props.theme.colors.dialogPopup.title};
  font-weight: 500;
  text-transform: uppercase;
  text-align: left;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  padding: 0;
  margin-bottom: 24px;
`
export const Description = styled.p`
  width: 100%;
  font-size: 20px;
  line-height: 1.5;
  padding: 0;
  margin-bottom: 24px;
  color: ${(props) => props.theme.colors.dialogPopup.text};
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  overflow: hidden;
`
export const SelectPopupHeader = styled.div`
  width: 100%;
  max-height: 230px;
  margin-bottom: 40px;
`
export const SelectPopupList = styled(FocusNode)`
  display: flex;
  width: 100%;
  margin-bottom: 68px;
  flex-direction: column;
`

export const SelectPopupFooter = styled(FocusNode)`
  display: flex;
  justify-content: space-between;
  width: 100%;
`

export const SelectOptionElem = styled(FocusNode)<{
  $isActive: boolean
}>`
  position: relative;
  width: 100%;
  display: flex;
  height: 64px;
  align-items: center;
  justify-content: flex-start;
  padding: 0 80px 0 30px;
  cursor: pointer;
  margin-bottom: 8px;
  background-color: ${(props) =>
    props.theme.colors.sidebar.activeElem.background};
  border-radius: 8px;
  overflow: hidden;

  & > div {
    display: flex;
    width: 100%;
    font-size: 20px;
    font-weight: 500;
    height: 64px;
    line-height: 64px;
    color: ${(props) => props.theme.colors.sidebar.text};
    opacity: ${({ $isActive }) => ($isActive ? '1' : '0.9')};
    align-items: center;

    img {
      display: inline-block;
      width: 40px;
      height: 40px;
      margin-right: 1rem;
      vertical-align: middle;
      object-fit: contain;
      &.checked {
        position: absolute;
        right: 0;
        top: 0;
        height: 64px;
      }
    }

    span {
      display: inline-block;
      vertical-align: middle;
      white-space: nowrap;
      text-overflow: ellipsis;
      overflow: hidden;
      &:first-letter {
        text-transform: capitalize;
      }
    }
  }

  &.isFocusedLeaf {
    background-color: ${(props) =>
      props.theme.colors.sidebar.focusedElem.background};
    box-shadow: inset 0 0 0 1px
        ${(props) => props.theme.colors.button.focusedElem.border},
      0 0 0 1px ${(props) => props.theme.colors.button.focusedElem.border};
  }
`
